/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';
import { ConcernsIssueSummaryDto } from '../concernsIssueSummaryDto.schema';

export const ListOfConcernsIssueSummaryDto = zod.array(zod.lazy(() => ConcernsIssueSummaryDto));

export type ListOfConcernsIssueSummaryDto = zod.input<typeof ListOfConcernsIssueSummaryDto>;
export type ListOfConcernsIssueSummaryDtoOutput = zod.output<typeof ListOfConcernsIssueSummaryDto>;
